import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnotationComponent } from './anotation.component';
import { DynamicContentDirective } from './dynamic-content.directive';
import { ParseUrl } from '@app/anotation/parse-url.pipe';


@NgModule({
   imports: [
      CommonModule
   ],
   declarations: [
      AnotationComponent,
      DynamicContentDirective,
      ParseUrl
   ],
   exports: [
    ParseUrl, 
    DynamicContentDirective
   ]
})
export class AnotationModule { }



// WEBPACK FOOTER //
// ./src/app/anotation/anotation.module.ts